import React from 'react'
import './Sidebar.css'
import SidebarOption from './SidebarOption'
import { Home, Search, LibraryMusic } from "@material-ui/icons";
import { useStateValue } from "../StateProvider";


function Sidebar() {
    const [{ playlists }, dispatch] = useStateValue()

    return (
        <div className='sidebar'>
            <img className='sidebar__logo' src="https://getheavy.com/wp-content/uploads/2019/12/spotify2019-830x350.jpg" alt="logo"/>
            
            <SidebarOption Icon={Home} title='Home' />
            <SidebarOption Icon={Search} title='Search' />
            <SidebarOption Icon={LibraryMusic} title='Your Library' />

            <br/>
            <strong className="sidebar__title">PLAYLISTS</strong>
            <hr/>

            {playlists?.items?.map(playlist => <SidebarOption title={playlist.name} />)}
            
        </div>
    )
}

export default Sidebar
